module.exports = __webpack_public_path__ + "img/across shoulder.49f53a8d.png";